// @ts-nocheck
import axios from 'axios';
import environment from 'environment/environment';

const instance = axios.create({
  baseURL: environment.backEnd
});

export const driversApi = axios.create({
  baseURL: environment.drivers
});

export const withHeadersInstance = axios.create({
  baseURL: environment.backEnd
});

export const apiMatchingKairox = axios.create({
  baseURL: environment.matching
});

export const apiExportKairox = axios.create({
  baseURL: environment.export
});

export const apiReservations = axios.create({
  baseURL: environment.reservation
});

export const apiTrafficLights = axios.create({
  baseURL: environment.trafficLights
});

withHeadersInstance.interceptors.request.use(function (config: any) {
  const token = `Bearer ${localStorage.getItem('token')}`;
  config.headers.Authorization = token;
  return config;
});

instance.interceptors.request.use(function (config: any) {
  const token = `Bearer ${localStorage.getItem('token')}`;
  config.headers.Authorization = token;
  return config;
});

instance.interceptors.response.use(
  (response: any) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response.data;
  },
  (error: any) => {
    if (axios.isCancel(error)) return Promise.reject(error);
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(new Error(error.response.data.messages.join('. ')));
  }
);

withHeadersInstance.interceptors.response.use(
  (response: any) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  (error: any) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error d
    return Promise.reject(new Error(error.response.data.messages.join('. ')));
  }
);

apiExportKairox.interceptors.request.use(function (config: any) {
  const token = `Bearer ${localStorage.getItem('token')}`;
  config.headers.Authorization = token;
  return config;
});

apiExportKairox.interceptors.response.use(
  (response: any) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  (error: any) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error d
    return Promise.reject(new Error(error.response.data.messages.join('. ')));
  }
);

apiReservations.interceptors.request.use(function (config) {
  const key = environment.reservationApiKey;
  config.headers['x-payment-key'] = key;
  return config;
});

apiReservations.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response) {
      // El servidor respondió con un status code fuera del rango 2xx
      const backendError = error.response.data;
      console.error('Error del backend:', backendError);

      // Transformamos el error para que sea más fácil de manejar
      const enhancedError = new Error(backendError.message || 'Error del servidor');
      enhancedError.response = error.response;
      return Promise.reject(enhancedError);
    } else if (error.request) {
      // La petición fue hecha pero no se recibió respuesta
      console.error('No se recibió respuesta del servidor');
      return Promise.reject(new Error('No se pudo conectar con el servidor'));
    } else {
      // Algo pasó al configurar la petición
      console.error('Error al configurar la petición:', error.message);
      return Promise.reject(error);
    }
  }
);

driversApi.interceptors.request.use(function (config: any) {
  const token = `Bearer ${localStorage.getItem('token')}`;
  config.headers.Authorization = token;
  return config;
});


apiTrafficLights.interceptors.request.use(function (config: any) {
  const token = `Bearer ${localStorage.getItem('token')}`;
  config.headers.Authorization = token;
  console.log(config);
  return config;
});


const getTrafficLightsErrorMessage = (error: any): string => {
  if (!error?.response?.data) {
    return error?.message || 'No se pudo conectar con el servidor';
  }
  const data = error.response.data;
  if (Array.isArray(data.errors) && data.errors.length > 0) {
    const parts = data.errors
      .map((e: { message?: string; key?: string }) => e?.message || e?.key)
      .filter(Boolean);
    if (parts.length) {
      return parts.join('. ');
    }
  }
  if (Array.isArray(data.messages) && data.messages.length > 0) {
    return data.messages.join('. ');
  }
  if (typeof data.message === 'string' && data.message) {
    return data.message;
  }
  return 'Error del servidor';
};

apiTrafficLights.interceptors.response.use(
  (response: any) => {
    return response.data;
  },
  (error: any) => {
    return Promise.reject(new Error(getTrafficLightsErrorMessage(error)));
  }
);
export default instance;
